export const CrossEye = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.47273 3.35636C7.97333 3.23918 8.48586 3.1806 9 3.18181C14.0909 3.18181 17 8.99999 17 8.99999C16.5585 9.82589 16.032 10.6034 15.4291 11.32M13.32 13.32C12.0768 14.2676 10.563 14.7926 9 14.8182C3.90909 14.8182 1 8.99999 1 8.99999C1.90465 7.3141 3.15937 5.84116 4.68 4.67999L13.32 13.32Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.68724 7C7.26259 7.42406 7 8.00949 7 8.65607C7 9.95059 8.05257 11 9.35099 11C9.99341 11 10.5757 10.7431 11 10.3267"
        stroke="currentColor"
      />
      <path
        d="M1 1L17 17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
